import DeleteIcon from '../DeleteIcon';
import React from 'react';
import './PageThumbnails.css';

const PageThumbnails = ({ pages, currentPage, onSelectPage, onDeletePage }) => {
    return (
        <div className="page-thumbnails">
            <h3>Páginas</h3>
            <div className="thumbnails-list">
                {pages.map((page, idx) => (
                    <div
                        key={idx}
                        className={`thumbnail-item ${currentPage === idx ? 'active' : ''}`}
                    >
                        <div className="thumbnail-preview" onClick={() => onSelectPage(idx)}>
                            {/* Vazio ou mini-preview */}
                        </div>
                        <div className="thumbnail-label">
                            {idx === 0 ? 'Capa' : idx}
                        </div>
                        {idx > 0 && onDeletePage && (
                            <button
                                className="btn-delete-page"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (window.confirm(`Apagar página "${page.name}"?`)) {
                                        onDeletePage(idx);
                                    }
                                }}
                                title="Apagar página"
                            >
                                <DeleteIcon />
                            </button>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PageThumbnails;
